"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.$SetupIntentResponseDto = void 0;
/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
exports.$SetupIntentResponseDto = {
    properties: {
        id: {
            type: 'string',
        },
        application: {
            type: 'one-of',
            contains: [{
                    type: 'string',
                }, {
                    type: 'StripeApplication',
                }],
            isNullable: true,
        },
        attach_to_self: {
            type: 'boolean',
            description: `Indica si el SetupIntent se asocia a sí mismo`,
        },
        automatic_payment_methods: {
            type: 'SetupIntentAutomaticPaymentMethods',
            isNullable: true,
        },
        cancellation_reason: {
            type: 'SetupIntentCancellationReason',
            isNullable: true,
        },
        client_secret: {
            type: 'string',
            isNullable: true,
        },
        created: {
            type: 'number',
        },
        customer: {
            type: 'one-of',
            contains: [{
                    type: 'string',
                }, {
                    type: 'StripeCustomer',
                }, {
                    type: 'StripeDeletedCustomer',
                }],
            isNullable: true,
        },
        description: {
            type: 'string',
            isNullable: true,
        },
        flow_directions: {
            type: 'array',
            contains: {
                type: 'SetupIntentFlowDirection',
            },
            isNullable: true,
        },
        last_setup_error: {
            type: 'SetupIntentLastSetupError',
            isNullable: true,
        },
        latest_attempt: {
            type: 'one-of',
            contains: [{
                    type: 'string',
                }, {
                    type: 'StripeSetupAttempt',
                }],
            isNullable: true,
        },
        livemode: {
            type: 'boolean',
        },
        mandate: {
            type: 'one-of',
            contains: [{
                    type: 'string',
                }, {
                    type: 'StripeMandate',
                }],
            isNullable: true,
        },
        metadata: {
            type: 'StripeMetadata',
            isNullable: true,
        },
        next_action: {
            type: 'SetupIntentNextAction',
            isNullable: true,
        },
        on_behalf_of: {
            type: 'one-of',
            contains: [{
                    type: 'string',
                }, {
                    type: 'StripeAccount',
                }],
            isNullable: true,
        },
        payment_method: {
            type: 'one-of',
            contains: [{
                    type: 'string',
                }, {
                    type: 'StripePaymentMethod',
                }],
            isNullable: true,
        },
        payment_method_configuration_details: {
            type: 'SetupIntentPaymentMethodConfigurationDetails',
            isNullable: true,
        },
        payment_method_options: {
            type: 'SetupIntentPaymentMethodOptions',
            isNullable: true,
        },
        payment_method_types: {
            type: 'array',
            contains: {
                type: 'string',
            },
        },
        single_use_mandate: {
            type: 'one-of',
            contains: [{
                    type: 'string',
                }, {
                    type: 'StripeMandate',
                }],
            isNullable: true,
        },
        status: {
            type: 'SetupIntentStatus',
        },
        usage: {
            type: 'string',
        },
    },
};
